<template>
  <div class="criterio-input-integer">
    <span class="criterio-subtitle">{{ label }}</span>

    <v-layout class="container-cumpon-range">
      <v-flex class="d-flex" cols="12" sm="12">
        <v-text-field v-model="value" :disabled="disabled" solo hide-details @input="input" @keypress="isNumber" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    currentIndex: Number,
    initialValue: {},
    values: {},
    componentParams: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    value: null,
  }),

  computed: {
    valueNumber() {
      if (!this.value) return 0
      if (typeof this.value === 'number') return Number(this.value)
      return Number(this.value.replace(',', '.'))
    },
  },

  watch: {
    label: function () {
      this.value = null
    },
  },

  mounted() {
    this.getData()
  },

  methods: {
    input() {
      window.clearTimeout(this.timeout)
      this.timeout = window.setTimeout(() => {
        this.$emit('input', { currentValue: this.valueNumber, currentIndex: this.currentIndex })
        this.validate()
      }, 500)
    },

    async validate() {
      this.$emit('validate', { isValid: await this.isValid(), currentIndex: this.currentIndex })
    },

    isValid() {
      return this.valueNumber > 0
    },

    isNumber(evt) {
      evt = evt || window.event
      const alreadyHaveSeparator = this.value && (this.value.includes(',') || this.value.includes(','))
      if (evt.key >= '0' && evt.key <= '9') {
        return true
      } else if (!alreadyHaveSeparator && (evt.key === ',' || evt.key === '.')) {
        return true
      } else {
        evt.preventDefault()
      }
    },

    getData() {
      if (this.initialValue) {
        this.value = String(this.initialValue)
      }
      this.validate()
    },
  },
}
</script>

<style lang="scss">
.criterio-input-integer {
  margin: 24px 0;

  .criterio-subtitle {
    font-size: 16px;
  }

  .container-cumpon-range {
    margin-top: 10px;

    p:nth-child(1) {
      margin-right: 15px;
    }
  }
}
</style>
